export default __webpack_public_path__ + "static/media/Trinket of Bone and Horn.c3e0f620.jpg";